import CasePerformanceWidget from './CasePerformanceWidget'

export default CasePerformanceWidget
